import styles from './style.module.css';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import moment from 'moment';

import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { List, ListItem } from '../../components/List';
import { HelmetComponent } from '../../components/Helmet';

import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { typeAccount, typePix } from '../../utils/accountData';
import { formatMoney } from '../../utils/formatMoney';
import { numberWithCommas } from '../../utils/numberWithCommas';
import { ITaxInvoice } from '../ConfrmRescue';

export function RescuesDetails() {
  const { rescueId } = useParams();
  const { client } = useAuth();
  const [rescue, setRescue] = useState<any>();
  const [isAwardMoney, setIsAwardMoney] = useState<boolean>(false);
  const [isAwardVariable, setIsAwardVariable] = useState(false);
  const [isAwardVoucher, setIsAwardVoucher] = useState<boolean>(false);
  const [rescueMoneyPix, setRescueMoneyPix] = useState<any>();
  const [rescueMoneyTed, setRescueMoneyTed] = useState<any>();
  const [taxInvoice, setTaxInvoice] = useState<ITaxInvoice | null>(null);

  useEffect(() => {
    getRescue();
  }, []);

  const getRescue = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getRescueById',
        userType: 'player',
        rescueId: rescueId,
        clientId: client && client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        const isMoney = data.data.rescue.awards.some(
          (item: any) => item.premiumType.value === 'BS2'
        );

        const isAwardVariable = data.data.rescue.awards.some(
          (item: any) => item.valueType && item.valueType.value === 'variable'
        );
        setIsAwardVariable(isAwardVariable);

        const findTypeAccount = typeAccount.find(
          (type) => type.value === data.data.rescue.accountData.accountType
        );
        if (findTypeAccount) setRescueMoneyTed(findTypeAccount);

        const findTypePix = typePix.find(
          (type) => type.value === data.data.rescue.accountData.typePix
        );
        if (findTypePix) setRescueMoneyPix(findTypePix);
        if (data.data.rescue.awards[0].premiumType.value === 'Digital')
          setIsAwardVoucher(true);
        setIsAwardMoney(isMoney);
        setRescue(data.data.rescue);
        if (data.data.rescue.taxInvoice) {
          setTaxInvoice(data.data.rescue.taxInvoice);
        }
      }
    } catch (error) {
      console.log('error getRescue', error);
    }
  };

  const renderQrCode = () => {
    return <QRCode value={rescue && rescue.id} size={100} className="mt-2" />;
  };

  const renderRescueMoney = () => {
    if (!rescue) return;
    return (
      <>
        <div className="col-sm-12 col-md-12">
          <div className="mt-3 mt-md-0">
            <span className="fw-semibold">Dados do resgate</span>
            <span
              className={`badge text-bg-${
                !rescue.statusTransfer
                  ? 'secondary'
                  : rescue.statusTransfer === 'FALHA' ||
                      rescue.statusTransfer === 'DEVOLVIDO'
                    ? 'danger'
                    : 'success'
              } float-end`}
            >
              {rescue.statusTransfer || 'AGUARDANDO LIBERAÇÃO'}
            </span>
          </div>
          <hr />
          <List>
            {rescueMoneyPix ? (
              <>
                <ListItem
                  icon="label"
                  content="Tipo de transferência"
                  secondaryContent="PIX"
                />
                <ListItem
                  icon="label"
                  content="Tipo de chave PIX"
                  secondaryContent={rescueMoneyPix.label}
                />
                <ListItem
                  icon="label"
                  content="Chave PIX"
                  secondaryContent={rescue.accountData.pixkey}
                />
              </>
            ) : (
              <>
                <ListItem
                  icon="label"
                  content="Tipo de transferência"
                  secondaryContent="TED"
                />
                <ListItem
                  icon="label"
                  content="Favorecido"
                  secondaryContent={rescue.accountData.name}
                />
                <ListItem
                  icon="label"
                  content="CPF"
                  secondaryContent={rescue.accountData.cpf}
                />
                <ListItem
                  icon="label"
                  content="Banco"
                  secondaryContent={rescue.accountData.labelBank}
                />
                <ListItem
                  icon="label"
                  content="Tipo de conta"
                  secondaryContent={rescueMoneyTed.label}
                />
                <ListItem
                  icon="label"
                  content="Agência"
                  secondaryContent={rescue.accountData.agency}
                />
                <ListItem
                  icon="label"
                  content="Conta"
                  secondaryContent={rescue.accountData.conta}
                />
              </>
            )}

            <ListItem
              icon="label"
              content={`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'} resgatados`}
              secondaryContent={numberWithCommas(
                Number(rescue.redeemedPoints).toFixed(2)
              )}
            />
            <ListItem
              icon="label"
              content="Dinheiro resgatado"
              secondaryContent={formatMoney(rescue.totalPaymentValue)}
            />
            <ListItem
              icon="label"
              content="Data do resgate"
              secondaryContent={moment(rescue.createdAt).format('DD/MM/YYYY')}
            />
            {rescue.statusTransferDescription && (
              <ListItem
                icon="label"
                content="Descrição do resgate"
                secondaryContent={rescue.statusTransferDescription}
                classStyle={styles.descriptionItem}
              />
            )}
            {taxInvoice && (
              <ListItem
                icon="label"
                content="Nota fiscal"
                secondaryContent={
                  <a
                    href={`https://${taxInvoice.fileUrl}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                }
              />
            )}
          </List>
        </div>
      </>
    );
  };

  const renderRescuePhisicOrDigital = () => {
    if (!rescue) return;
    return (
      <div className="col-sm-12 col-md-12">
        <div className="mt-3 mt-md-0">
          <span className="fw-semibold">Dados do resgate</span>
        </div>
        <hr />
        <List>
          <ListItem
            icon="label"
            content={`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'} resgatados`}
            secondaryContent={rescue.redeemedPoints}
          />
          <ListItem
            icon="label"
            content="Data do resgate"
            secondaryContent={moment(rescue.createdAt).format('DD/MM/YYYY')}
          />
          {isAwardVoucher &&
            rescue?.vouchers?.map((item, index) => (
              <>
                <ListItem
                  icon="paid"
                  content={`Valor do voucher ${index + 1}`}
                  secondaryContent={item.value}
                />
                <ListItem
                  icon="redeem"
                  content={`Código do voucher ${index + 1}`}
                  secondaryContent={item.voucher}
                />
              </>
            ))}
        </List>
      </div>
    );
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Detalhes do resgate'}
      />
      <div className="container">
        <div className="row">
          <ButtonBack title="Detalhes do resgate" />
        </div>
        {(rescue && !isAwardMoney) ||
          (isAwardVoucher && (
            <div className="row">
              <div className="col-sm-12">
                <List>
                  <ListItem
                    icon="label"
                    content="Código do resgate"
                    secondaryContent={renderQrCode()}
                  />
                </List>
              </div>
            </div>
          ))}

        <>
          <div className="row">
            <div className="my-3">
              <Card>
                <div className="row">
                  {rescue && isAwardMoney
                    ? renderRescueMoney()
                    : renderRescuePhisicOrDigital()}
                </div>
              </Card>
            </div>
          </div>
          <div className="row">
            {rescue &&
              rescue.awards.map((award: any) => (
                <div className="my-3 col-sm-12 col-md-6 col-xl-4">
                  <Card>
                    <div className="d-flex">
                      <div className="d-block">
                        <div className={styles.imageRescue}>
                          <img src={award.premiumImage} alt="" />
                        </div>
                      </div>
                      <div className="d-block ms-3">
                        <span className="fs-6 fw-semibold d-block">
                          {award.premiumName}
                        </span>
                        <span className="fs-6 fw-semibold d-block">
                          {award.amount === 1
                            ? `${award.amount} item`
                            : `${award.amount} itens`}
                        </span>

                        <span className="fs-6 fw-semibold d-block">
                          {rescue && isAwardMoney && isAwardVariable ? (
                            <>
                              {Number(rescue.redeemedPoints) === 1
                                ? `${numberWithCommas(
                                    Number(rescue.redeemedPoints).toFixed(2)
                                  )} ${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`
                                : `${numberWithCommas(
                                    Number(rescue.redeemedPoints).toFixed(2)
                                  )} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                            </>
                          ) : (
                            <>
                              {award.premiumPrice === 1
                                ? `${numberWithCommas(
                                    award.premiumPrice.toFixed(2)
                                  )} ${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`
                                : `${numberWithCommas(
                                    award.premiumPrice.toFixed(2)
                                  )} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                            </>
                          )}
                        </span>
                        {rescue && isAwardMoney && (
                          <span className="fs-6 fw-semibold d-block">
                            {formatMoney(award.paymentValue)}
                          </span>
                        )}
                        {rescue && isAwardMoney && isAwardVariable && (
                          <span className="fs-6 fw-semibold d-block">
                            {formatMoney(rescue.totalPaymentValue)}
                          </span>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
          </div>
        </>
      </div>
    </>
  );
}
